import { render, staticRenderFns } from "./CustomFolderViewDetails.vue?vue&type=template&id=301141b2&"
import script from "./CustomFolderViewDetails.vue?vue&type=script&lang=js&"
export * from "./CustomFolderViewDetails.vue?vue&type=script&lang=js&"
import style0 from "./CustomFolderViewDetails.vue?vue&type=style&index=0&id=301141b2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports